<template>
  <div class="circle-list">
    <!-- Tab切换 -->
    <div class="filter-tabs">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="我创建的" name="created"></el-tab-pane>
        <el-tab-pane label="我加入的" name="joined"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 顶部操作栏 -->
    <div class="action-bar">
      <div class="search-bar">
        <el-input 
          v-model="keyword"
          placeholder="搜索圈子"
          @keyup.enter.native="search"
          clearable
        >
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
      </div>
    </div>

    <!-- 圈子列表 -->
    <div class="circle-container">
      <el-card 
        v-for="item in circles" 
        :key="item.id" 
        class="circle-item"
        @click.native="goDetail(item)"
      >
        <div class="circle-header">
          <el-avatar :size="60" :src="item.avatar"/>
          <div class="circle-info">
            <h3 class="circle-name">{{item.name}}</h3>
            <p class="circle-desc">{{item.description}}</p>
            <div class="circle-meta">
              <span>{{item.memberCount}}成员</span>
              <span>{{item.postCount}}帖子</span>
            </div>
            <!-- 状态标签 -->
            <div class="circle-status">
              <!-- 公开状态 -->
              <el-tag 
                :type="item.isOpen=='Y' ? 'success' : 'warning'"
                size="mini"
                class="status-tag"
                effect="dark"
              >
                {{ item.isOpen=='Y' ? '公开' : '私密' }}
              </el-tag>
              <!-- 审核状态 -->
              <el-tag v-if="item.approved=='N'"
                type="warning"
                size="mini"
                class="status-tag"
              >
                审核不通过
              </el-tag>
            </div>
          </div>
          <el-tag v-if="item.price > 0" type="danger">
            ¥{{item.price}}
          </el-tag>
        </div>
      </el-card>
    </div>
    <el-empty
        v-if="circles.length==0"
        description="无数据"
    ></el-empty>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        :current-page="page"
        :page-size="10"
        :total="total"
        @current-change="handlePageChange"
        layout="prev, pager, next"
      />
    </div>

    <!-- 创建按钮 -->
    <el-button
      v-if="userStore.userInfo.id"
      class="create-btn"
      type="primary"
      circle
      @click="createCircle"
    >
      <i class="el-icon-plus"></i>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'CircleList',
  
  data() {
    return {
      keyword: '',
      circles: [],
      page: 1,
      total: 0,
      showManageDialog: false,
      showEssenceDialog: false,
      showTopDialog: false,
      essencePosts: [],
      topPosts: [],
      activeTab: 'created' // 当前选中的tab
    }
  },

  created() {
    this.getCircleList()
  },

  methods: {
    // Tab切换处理
    handleTabChange() {
      this.getCircleList()
    },

    // 获取圈子列表
    async getCircleList() {
      try {
        const res = await this.$http2({
          url: this.activeTab === 'created'?'/klgeek/circle/list':'/klgeek/circle/joinlist',
          method: 'get',
          params: {
            pageNum: this.page,
            pageSize: 10,
            name: this.keyword,
            createBy:  this.userStore.userInfo.id
          }
        })
        this.circles = res.rows
        this.total = res.total
      } catch(e) {
        console.error(e)
      }
    },

    // 搜索
    search() {
      this.page = 1
      this.getCircleList()
    },

    // 页码变化
    handlePageChange(val) {
      this.page = val
      this.getCircleList()
    },

    // 跳转到圈子详情
    goDetail(circle) {
      this.$router.push(`/home/community/post-list/${circle.id}`)
    },

    // 跳转到我的圈子
    goMyCircle() {
      this.$router.push('/community/my-circle')
    },

    // 创建圈子
    createCircle() {
      this.$router.push('/home/community/circle-detail')
    },

    // 显示管理弹窗
    showEditPopup() {
      this.showManageDialog = true
    },

    // 编辑圈子
    editCircle() {
      this.showManageDialog = false
      this.$router.push(`/home/community/circle-detail?id=${this.$route.params.id}`)
    },

    // 精华管理
    async manageEssence() {
      this.showManageDialog = false
      try {
        const res = await this.$http2({
          url: '/klgeek/post/essence/list',
          params: {
            circleId: this.$route.params.id
          }
        })
        this.essencePosts = res.rows
        this.showEssenceDialog = true
      } catch(e) {
        console.error(e)
      }
    },

    // 取消精华
    async cancelEssence(post) {
      try {
        await this.$http2({
          url: `/klgeek/post/essence/${post.id}`,
          method: 'DELETE'
        })
        this.$message.success('已取消精华')
        this.essencePosts = this.essencePosts.filter(p => p.id !== post.id)
        this.getCircleList() // 刷新列表
      } catch(e) {
        console.error(e)
      }
    },

    // 置顶管理
    async manageTop() {
      this.showManageDialog = false
      try {
        const res = await this.$http2({
          url: '/klgeek/post/top/list',
          params: {
            circleId: this.$route.params.id
          }
        })
        this.topPosts = res.rows
        this.showTopDialog = true
      } catch(e) {
        console.error(e)
      }
    },

    // 取消置顶
    async cancelTop(post) {
      try {
        await this.$http2({
          url: `/klgeek/post/top/${post.id}`,
          method: 'DELETE'
        })
        this.$message.success('已取消置顶')
        this.topPosts = this.topPosts.filter(p => p.id !== post.id)
        this.getCircleList() // 刷新列表
      } catch(e) {
        console.error(e)
      }
    },

    // 获取审核状态类型
    getAuditStatusType(status) {
      switch (status) {
        case 0:
          return 'warning'
        case 1:
          return 'success'
        case 2:
          return 'danger'
        default:
          return 'info'
      }
    },

    // 获取审核状态文本
    getAuditStatusText(status) {
      switch (status) {
        case 0:
          return '审核中'
        case 1:
          return '审核通过'
        case 2:
          return '审核未通过'
        default:
          return '未知状态'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.circle-list {
  padding: 20px;
  
  .filter-tabs {
    background: #fff;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 20px;

    :deep(.el-tabs__header) {
      margin: 0;
    }

    :deep(.el-tabs__nav-wrap::after) {
      display: none;
    }

    :deep(.el-tabs__active-bar) {
      background-color: #ff6b00;
    }

    :deep(.el-tabs__item) {
      font-size: 15px;
      color: #666;
      padding: 0 20px;

      &.is-active {
        color: #ff6b00;
        font-weight: 500;
      }

      &:hover {
        color: #ff6b00;
      }
    }
  }
  
  .action-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    .search-bar {
      width: 300px;
      margin-right: 20px;
    }
  }
  
  .circle-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 20px;
    
    .circle-item {
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
      }
      
      .circle-header {
        display: flex;
        align-items: flex-start;
        
        .circle-info {
          flex: 1;
          margin: 0 15px;
          
          .circle-name {
            margin: 0 0 10px;
            font-size: 16px;
          }
          
          .circle-desc {
            margin: 0 0 10px;
            font-size: 14px;
            color: #666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          
          .circle-meta {
            font-size: 13px;
            color: #999;
            
            span {
              margin-right: 15px;
            }
          }
          
          .circle-status {
            margin-top: 8px;
            
            .status-tag {
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
  
  .pagination {
    display: flex;
    justify-content: center;
  }
  
  .create-btn {
    position: fixed;
    right: 40px;
    bottom: 40px;
  }
}
</style> 